<template>
    <common-modal width="wide">
        <common-content-spacer height="medium" class="all-ratings-modal">
            <single-rating v-for="rating in ratings" :key="rating.id" :rating="rating"></single-rating>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import SingleRating from 'components/page-elements/rating/SingleRating'

    export default {
        components: { SingleRating },

        props: {
            ratings: { type: Object, required: true },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .all-ratings-modal {
        margin: 50px 0;
        max-height: 500px;
        @include breakpoint(smartphone-large) {
            min-height: 85%;
        }
        overflow: scroll;
        overflow-x: hidden;
    }
</style>
